import { Stack, Pagination } from "@mui/material"
import Div from "../../../components/Div";
import Input from "../../../components/Input";
import { useState, useEffect, useCallback } from "react";
import PageTitle from "../../../components/PageTitle";
import FormButton from "../../../components/FormButton"; 
import { getKREDomainsHttp } from "../../../http/renewalHttp/RenewalHttp";
import InsertMeetingModal from "../../../components/Renewal/InsertMeetingModal"; 
import ViewMeetingDataModal from "../../../components/Renewal/ViewMeetingDataModal";

export default function RenewalMeetings() {
    const [customerList, setCustomerList] = useState([]);
    const [initailCustomerList, setInitialCustomerList] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [insertMeeting, setInsertMeeting] = useState(false); // State to handle modal
    const itemsPerPage = 10;
    const [viewMeetingData, setViewMeetingData] = useState(false);

    // Renamed fetch function specifically for KRE Domains
    const getKREDomains = useCallback(async () => {
        const response = await getKREDomainsHttp(); 
        if (response) {
            // response.customer should contain the list of domains
            setCustomerList(response.customer);
            setInitialCustomerList(response.customer);
        } else {
            setCustomerList([]);
            setInitialCustomerList([]);
        }
    }, []);

    useEffect(() => {
        getKREDomains();
    }, [getKREDomains])

    // Pagination Logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = customerList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(customerList.length / itemsPerPage);

    const paginate = (event, value) => {
        setCurrentPage(value);
    };

    
    function handleSearchCustomer(event) {
        const search_item = event.target.value;
        const filteredList = initailCustomerList.filter((customer) => {
            if (customer && customer.customerDomain) {
                return customer.customerDomain.toLowerCase().includes(search_item.toLowerCase());
            }
            return false;
        });
        setCustomerList(filteredList);
        setSearch(search_item);
        setCurrentPage(1); 
    }

    // Function to handle the button click
    function handleInsertMeeting(customer) {
        setInsertMeeting(customer); // Pass the whole customer object to the state
    }

    return (
        <>
            {/* Modal for viewing data */}
            {viewMeetingData ? 
                <ViewMeetingDataModal 
                    customer_data={viewMeetingData} 
                    handleClicked={setViewMeetingData} 
                /> : null
            }
        
      {/* added by siddhi */}
        {insertMeeting ? 
            <InsertMeetingModal 
                customer_data={insertMeeting} 
                handleClicked={setInsertMeeting} 
            /> : null
        }
            {/* Modal will be added here in the next step */}
            <PageTitle title={`Renewal Meetings`} />
            <Div className="col-md-12">
                <Div className="page-header-toolbar">
                    <Div className="btn-group toolbar-item" role="group" >
                        <Input 
                            type='text' 
                            placeholder="Search Customer Domain..."
                            name='text' 
                            id='text' 
                            style={{ marginLeft: '50px', width: '300px' }} 
                            value={search}
                            onChange={handleSearchCustomer}
                        />
                    </Div>
                </Div>
            </Div>

            <Div className="col-md-12 margin_top" style={{ opacity: '0.9' }} >
                {customerList.length > 0 ? (
                    <table className="table" border="1">
                        <thead>
                            <tr>
                                <th>Customer Domain</th>
                                <th>Zone</th>
                                <th>Segments</th>
                                <th>Assigned to</th>
                                <th>Insert Meeting</th> 
                                <th>View Meeting Data</th>
                            </tr>
                        </thead>
                        <tbody id="tableBody">
                            {currentItems.map((customer, index) => (
                                <tr key={index}>
                                    <td>{customer.customerDomain}</td>
                                    <td>{customer.zone_update}</td>
                                    <td>{customer.segments}</td>
                                    <td>{customer.assigned_to}</td>
                                    <td> 
                                        <FormButton 
                                            type="button" 
                                            className="btn btn-primary btn-sm"
                                            onClick={() => setInsertMeeting(customer)}
                                        >
                                            Insert Meeting
                                        </FormButton>
                                    </td>

                                    <td> 
                            <FormButton 
                                className="btn btn-info btn-sm"
                                onClick={() => setViewMeetingData(customer)}
                            >
                                View Data
                            </FormButton>
                        </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p style={{ marginTop: '30px' }}>No Domain Present or Could not fetch Domains</p>
                )}

                {customerList.length > 0 && (
                    <Stack spacing={2}>
                        <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate} />
                    </Stack>
                )}
            </Div>
        </>
    );
}